export class CreateDriverJsonModel {
  // MotoristaRegisterObj
  public Nome = ''
  public Cpf = ''
  public Email = ''
  public Senha = ''
  public Matricula = ''
  public DataNascimento = ''
  public DataContratacao = ''
  public StatusId = 0
  public TipoMotoristaId = 0
  public NumeroRegistro = ''
  public Categoria = ''
  public Validade = ''
  public IsFuncionario: 'S' | 'N' = 'N'

  //fornecedor
  public FornecedorId: number | null = null
  public IsAutonomo: 'S' | 'N' = 'N'
  public Cnpj = ''
  public InscricaoEstadual = ''
  public InscricaoMunicipal = ''
  public NomeFantasia = ''
  public RazaoSocial = ''
  public FornecedorExiste: 'S' | 'N' = 'N'

  // MotoristaEnderecoRegisterObj
  public TipoEnderecoId = 0
  public Cep = ''
  public Logradouro = ''
  public Numero = ''
  public Complemento = ''
  public Bairro = ''
  public Estado = ''
  public Cidade = ''
  public Pais = ''
  public Latitude = ''
  public Longitude = ''

  // MotoristaContatoObj
  public Contatos: contact[] = []

  // MotoristaUploadObj
  public Files: file[] = []
}

export class EditDriverModel {
  public id = 0
  public descricao = ''
}

export class DeleteDriverModel {
  public id = 0
  public descricao = ''
}

export class SearchDriverModel {
  public descricao = ''
}

export class CreateDriverResponse {
  public response: any
}
export class EditDriverResponse {
  public response: any
}
export class DeleteDriverResponse {
  public response: any
}
export class PagedDriverResponse {
  public response: any
}
export class CreateDriverModel extends CreateDriverJsonModel {
  public toFormData(): FormData {
    const formData = new FormData()

    // MotoristaRegisterObj
    formData.append('MotoristaRegisterObj.Nome', this.convertString(this.Nome))
    formData.append('MotoristaRegisterObj.Cpf', this.convertString(this.Cpf))
    formData.append(
      'MotoristaRegisterObj.Email',
      this.convertString(this.Email),
    )
    formData.append(
      'MotoristaRegisterObj.Senha',
      this.convertString(this.Senha),
    )
    formData.append(
      'MotoristaRegisterObj.Matricula',
      this.convertString(this.Matricula),
    )
    formData.append(
      'MotoristaRegisterObj.DataNascimento',
      this.convertString(this.DataNascimento),
    )
    formData.append(
      'MotoristaRegisterObj.DataContratacao',
      this.convertString(this.DataContratacao),
    )
    formData.append(
      'MotoristaRegisterObj.StatusId',
      this.convertString(this.StatusId),
    )
    formData.append(
      'MotoristaRegisterObj.TipoMotoristaId',
      this.convertString(this.TipoMotoristaId),
    )
    formData.append(
      'MotoristaRegisterObj.NumeroRegistro',
      this.convertString(this.NumeroRegistro),
    )
    formData.append(
      'MotoristaRegisterObj.Categoria',
      this.convertString(this.Categoria),
    )
    formData.append(
      'MotoristaRegisterObj.Validade',
      this.convertString(this.Validade),
    )
    formData.append(
      'MotoristaRegisterObj.IsFuncionario',
      this.convertString(this.IsFuncionario),
    )

    // Info Fornecedor
    formData.append(
      'MotoristaRegisterObj.FornecedorId',
      this.convertString(this.FornecedorId),
    )
    formData.append(
      'MotoristaRegisterObj.IsAutonomo',
      this.convertString(this.IsAutonomo),
    )
    formData.append('MotoristaRegisterObj.Cnpj', this.convertString(this.Cnpj))
    formData.append(
      'MotoristaRegisterObj.InscricaoEstadual',
      this.convertString(this.InscricaoEstadual),
    )
    formData.append(
      'MotoristaRegisterObj.InscricaoMunicipal',
      this.convertString(this.InscricaoMunicipal),
    )
    formData.append(
      'MotoristaRegisterObj.NomeFantasia',
      this.convertString(this.NomeFantasia),
    )
    formData.append(
      'MotoristaRegisterObj.RazaoSocial',
      this.convertString(this.RazaoSocial),
    )
    formData.append(
      'MotoristaRegisterObj.FornecedorExiste',
      this.convertString(this.FornecedorExiste),
    )

    // MotoristaEnderecoRegisterObj
    formData.append(
      'MotoristaEnderecoRegisterObj.TipoEnderecoId',
      this.convertString(this.TipoEnderecoId),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Cep',
      this.convertString(this.Cep),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Logradouro',
      this.convertString(this.Logradouro),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Numero',
      this.convertString(this.Numero),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Complemento',
      this.convertString(this.Complemento),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Bairro',
      this.convertString(this.Bairro),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Estado',
      this.convertString(this.Estado),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Cidade',
      this.convertString(this.Cidade),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Pais',
      this.convertString(this.Pais),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Latitude',
      this.convertString(this.Latitude),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Longitude',
      this.convertString(this.Longitude),
    )

    // MotoristaContatoObj
    if (this.Contatos) {
      for (let index = 0; index < this.Contatos.length; index++) {
        const contato = this.Contatos[index]
        if (contato.tipoContatoId >= 0 && contato.descricao) {
          formData.append(
            `MotoristaContatoObj[${index}].TipoContatoId`,
            this.convertString(contato.tipoContatoId),
          )
          formData.append(
            `MotoristaContatoObj[${index}].Descricao`,
            this.convertString(contato.descricao),
          )
        }
      }

      // for (const contato of this.Contatos) {
      //   if (contato.TipoContatoId >= 0 && contato.Descricao) {
      //     formData.append(
      //       `MotoristaContatoObj[${index}].TipoContatoId`,
      //       this.convertString(contato.TipoContatoId),
      //     )
      //     formData.append(
      //       'MotoristaContatoObj.Descricao',
      //       this.convertString(contato.Descricao),
      //     )
      //   }
      // }
    }

    // MotoristaUploadObj
    if (this.Files) {
      for (let index = 0; index < this.Files.length; index++) {
        const file = this.Files[index]
        if (file.TipoDocId >= 0 && file.Descricao && file.Arquivo) {
          formData.append(
            `MotoristaUploadObj[${index}].TipoDocId`,
            this.convertString(file.TipoDocId),
          )
          formData.append(
            `MotoristaUploadObj[${index}].Descricao`,
            this.convertString(file.Descricao),
          )
          formData.append(`MotoristaUploadObj[${index}].Arquivo`, file.Arquivo)
        }
      }
      // for (const file of this.Files) {
      //   if (file.TipoDocId >= 0 && file.Descricao && file.Arquivo) {
      //     formData.append(
      //       'MotoristaUploadObj.TipoDocId',
      //       this.convertString(file.TipoDocId),
      //     )
      //     formData.append(
      //       'MotoristaUploadObj.Descricao',
      //       this.convertString(file.Descricao),
      //     )
      //     formData.append('MotoristaUploadObj.Arquivo', file.Arquivo)
      //   }
      // }
    }

    return formData
  }

  private convertString(value: any) {
    return value ? value.toString() : ''
  }
}

class contact {
  public tipoContatoId = 0
  public descricao = ''
}

class file {
  public TipoDocId = 0
  public Descricao = ''
  public Arquivo: File | null = null
}
